// extracted by mini-css-extract-plugin
export default {"adminTextControls":"AdminText_adminTextControls__sjmgq","adminTextToggle":"AdminText_adminTextToggle__TSTWY","adminTextEditor":"AdminText_adminTextEditor__a-5Vr"};